import {MODALS_IDS} from '@Components/modal-container';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import type {PremiumAgreementModalProps} from '@Modals/premium-agreement-modal/premium-agreement-modal.types';

export const openPremiumAgreementModal = (props: PremiumAgreementModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.PREMIUM_AGREEMENT_MODAL,
      panelProps: props,
    })
  );
};
